export default (build) =>
  build.mutation({
    query: ({ uid }) => ({
      url: `/superadmin/admin-status/${uid}`,
      method: "POST",
    }),
    invalidatesTags: ["Users"],
  });
